var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.2,
    height: 18,
    viewBox: "0 0 22.2 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "format-list-bulleted",
    d: "M7.9,5.1H24.7V7.5H7.9V5.1m0,9.6V12.3H24.7v2.4H7.9M4.3,4.5A1.8,1.8,0,1,1,2.5,6.3,1.8,1.8,0,0,1,4.3,4.5m0,7.2a1.8,1.8,0,1,1-1.8,1.8,1.8,1.8,0,0,1,1.8-1.8M7.9,21.9V19.5H24.7v2.4H7.9m-3.6-3a1.8,1.8,0,1,1-1.8,1.8,1.8,1.8,0,0,1,1.8-1.8Z",
    transform: "translate(-2.5 -4.5)",
    fill: "#031f69"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoList);
export default __webpack_public_path__ + "static/media/ico-list.2b5dabbc1639cfc25b2bc0a0c3fc28ce.svg";
export { ForwardRef as ReactComponent };